import { render, staticRenderFns } from "./GetAQuote.vue?vue&type=template&id=2efd5d3a&scoped=true&"
import script from "./GetAQuote.vue?vue&type=script&lang=js&"
export * from "./GetAQuote.vue?vue&type=script&lang=js&"
import style0 from "./GetAQuote.vue?vue&type=style&index=0&id=2efd5d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd5d3a",
  null
  
)

export default component.exports